import Swal from "sweetalert2";

export class Alert {
  // Preguntar al usuario si esta seguro de realizar la acción
  confirmacion() {
    return Swal.fire({
      title: "¿Estás seguro?",
      text: "¡No podrás revertir esto!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#5b6b67",
      cancelButtonColor: "#a12040",
      cancelButtonText: "Cancelar",
      confirmButtonText: "¡Sí, bórralo!",
    });
  }
  // Modal de cargando...
  cargando(text?: string) {
    function loading() {
      Swal.fire({
        title: "Espere, por favor!",
        text: text ? text : "CARGANDO...",
        type: "info",
        allowOutsideClick: false,
      });
      Swal.showLoading();
    }
    return loading();
  }

  // Close loading
  closeLoading() {
    Swal.close();
  }
  // Modal de error despues de intentar guardar
  error() {
    return Swal.fire({
      allowOutsideClick: false,
      type: "error",
      title: "Error al guardar",
      text: "Intentalo nuevamente!",
    });
  }
  // Modal de guardado correctamenta despues de guardar
  correcto() {
    return Swal.fire({
      allowOutsideClick: false,
      type: "success",
      title: "Guardado!",
      text: "Se guardo correctamente.",
    });
  }
  // Modal de error personalizado
  errorCustom(mensaje: string) {
    return Swal.fire({
      type: "error",
      title: "Ups...",
      text: `${mensaje}`,
      confirmButtonColor: "#a12040",
    });
  }
  // Modal de eliminado correctamenta despues de eliminar

  eliminar() {
    return Swal.fire({
      allowOutsideClick: false,
      type: "success",
      title: "Eliminado!",
      text: "Se elimino correctamente.",
    });
  }

  async selectYear() {
    const { value: year } = await Swal.fire({
      allowOutsideClick: false,
      title: "Seleccione un año",
      input: "radio",
      confirmButtonColor: "#325a4f",
      confirmButtonText: "Entrar <i class='fas fa-arrow-right'></i>",
      inputOptions: {
        "2020": "<p style='color: #a12040'>2020</p>",
        "2021": "<p style='color: #325a4f'>2021</p>",
        "2022": "<p style='color: #325a4f'>2022</p>",
        "2023": "<p style='color: #a12040'>2023</p>",
      },
      backdrop: "rgb(169,169,169)",
      inputValidator: (value) => {
        if (!value) {
          return "¡Tiene que elegir una opción!";
        }
      },
    });
    if (year) {
      // Swal.fire({ html: `You selected: ${year}` });
      return year;
    }
  }
}
